import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAddressBook,
  // faAnalytics,
  faArchive,
  faAtom,
  // faArrowAltUp,
  faBalanceScale,
  faBan,
  faBookmark,
  faBriefcase,
  faBriefcaseMedical,
  faBuilding,
  faCalculator,
  faCalendar,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faCircle,
  faClipboardList,
  // faClipboardListCheck,
  // faCloudDownload,
  // faCloudUpload,
  faCog,
  faCogs,
  faComment,
  faCommentAlt,
  faComments,
  faCreditCard,
  faDollarSign,
  faEdit,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faFileAlt,
  faFilePdf,
  // faFilePlus,
  // faFileUser,
  faFileWord,
  faGavel,
  faGlobe,
  faHandHoldingUsd,
  faHandshake,
  // faHandshakeAlt,
  faHome,
  // faIndustryAlt,
  faInfoCircle,
  faKey,
  faLifeRing,
  faLink,
  // faLockAlt,
  // faMindShare,
  faMinusSquare,
  faMoneyBill,
  faPaperclip,
  faPenAlt,
  faPlusSquare,
  faPuzzlePiece,
  faQuestionCircle,
  faRegistered,
  faSearch,
  faShareAlt,
  // faSignOut,
  faSitemap,
  faSlash,
  faSortUp,
  faSortDown,
  faStar,
  faStethoscope,
  faTable,
  faThumbtack,
  faUniversity,
  faUpload,
  // faUsdCircle,
  faUser,
  faUserFriends,
  faUserPlus,
  faUsers,
  faUserSecret,
  faUserTimes,
  faArrowRight,
  faArrowLeft,
  faExclamation,
  faPenAlt as fasPenAlt
} from '@fortawesome/free-solid-svg-icons'

// import { faArrowRight, faArrowLeft, faExclamation, faPenAlt as fasPenAlt } from '@fortawesome/free-solid-svg-icons'

library.add(
  faAddressBook,
  faAtom,
  faArchive,
  // faAnalytics,
  // faArrowAltUp,
  faArrowLeft,
  faArrowRight,
  faBalanceScale,
  faBan,
  faBookmark,
  faBriefcase,
  faBriefcaseMedical,
  faBuilding,
  faCalculator,
  faCalendar,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faCircle,
  faClipboardList,
  // faClipboardListCheck,
  // faCloudDownload,
  // faCloudUpload,
  faCog,
  faCogs,
  faComment,
  faCommentAlt,
  faComments,
  faCreditCard,
  faDollarSign,
  faEdit,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faFileAlt,
  faFilePdf,
  // faFilePlus,
  // faFileUser,
  faFileWord,
  faGavel,
  faGlobe,
  faHandHoldingUsd,
  faHandshake,
  // faHandshakeAlt,
  faHome,
  // faIndustryAlt,
  faInfoCircle,
  faKey,
  faLifeRing,
  faLink,
  // faLockAlt,
  // faMindShare,
  faMinusSquare,
  faMoneyBill,
  faPaperclip,
  faPenAlt,
  faPlusSquare,
  faPuzzlePiece,
  faQuestionCircle,
  faRegistered,
  faSearch,
  faShareAlt,
  // faSignOut,
  faSitemap,
  faSlash,
  faSortUp,
  faSortDown,
  fasPenAlt,
  faStar,
  faStethoscope,
  faTable,
  faThumbtack,
  faUniversity,
  faUpload,
  // faUsdCircle,
  faUser,
  faUserFriends,
  faUserPlus,
  faUsers,
  faUserSecret,
  faUserTimes
)

export default library
